// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/wildlife-farm-overflight.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/wildlife-farm-overflight/wildlife-farm-overflight.js';

mount([g0]);
